export enum SameSite {
    Strict = "Strict",
    Lax = "Lax",
    None = "None"
}
